// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1LabelSchema } from './v1/labelSchema';

export const listTagsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listTagsQueryParamsSchema = z.object({
  limit: z.optional(z.number().int().describe("Maximum number of labels to return (default: 10000)")),
  offset: z.optional(z.number().int().describe("Number of labels to skip (default: 0)")),
  filter: z.optional(z.enum(["all", "active", "archived"]).describe("Filter labels by status: all (default), active, or archived")),
  parent_id: z.optional(z.number().int().describe("Filter by parent label ID to get child labels only")),
}).optional();

export const listTagsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Child labels retrieved successfully
 */
export const listTags200Schema = z.lazy(() => v1LabelSchema);

export const listTagsQueryResponseSchema = z.lazy(() => listTags200Schema);
